import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
  IsArray,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
export interface ListAgentUserResponse {
  total: number;
  page: number;
  page_size: number;
  list: Users[];
};

export interface Users {
  id: number;
  user_sub_id: string;
  user_name: string;
  email: string;
  role_type: number;
  permissions: string[];
  role_status: number;
  app_status: number;
  subscription?: string;
  expire_at?: string;
  created_at: string;
  last_login_at: string;
};

// 请求接口
interface ListAgentUsersRequest {
  agentId: string,
  searchType: string, // email | user_name | user_id
  inputText: string, // 针对searchType的模糊查询
  roleType: number, // 1=运营, 2=管理员, 3=超级管理员, 4=付费用户
  roleStatus: number, // 1=启用 0=禁用
  page: number,
  pageSize: number
}

export class PermissionUserData {
  @Required("Id cannot be empty")
  @IsString("Id must be a string")
  id: string;

  @Required("User sub id cannot be empty")
  @IsString("User sub id must be a string")
  userSubId: string;

  @Required("Username cannot be empty")
  @IsString("Username must be a string")
  userName: string;

  @Required("Email cannot be empty")
  @IsString("Email must be a string")
  email: string;

  @Required("Role type cannot be empty")
  @IsNumber("Role type must be a number")
  roleType: number;

  @Required("Role status cannot be empty")
  @IsNumber("Role status must be a number")
  roleStatus: number;

  @Required("App status cannot be empty")
  @IsNumber("App status must be a number")
  appStatus: number;

  @Required("Permissions cannot be empty")
  @IsArray("Permissions must be an array")
  permissions: string[];

  @Required("Subscription cannot be empty")
  @IsString("Subscription must be a string")
  subscription: string;

  @Required("Expire at cannot be empty")
  @IsString("Expire at must be a string")
  expireAt: string;

  @Required("Created at cannot be empty")
  @IsString("Created at must be a string")
  createdAt: string;

  @Required("Last login at cannot be empty")
  @IsString("Last login at must be a string")
  lastLoginAt: string;
}

export class ListAgentUsersData {
  @IsArray("List must be an array")
  list: PermissionUserData[];

  @Required("Total cannot be empty")
  @IsNumber("Total must be a number")
  total: number;

  @Required("Page cannot be empty")
  @IsNumber("Page must be a number")
  page: number;

  @Required("Page size cannot be empty")
  @IsNumber("Page size must be a number")
  pageSize: number;
}

const transformAndValidateAgent = (
  response: ListAgentUserResponse
): ListAgentUsersData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, ListAgentUsersData);
  } catch (error) {
    console.error("Agent User data validation failed:", error.message);
    throw error;
  }
};

/** 获取 Agent 权限用户列表 */
export const listAgentUsers = async ({
  page,
  pageSize,
  agentId,
  searchType,
  inputText,
  roleType,
  roleStatus
}: ListAgentUsersRequest): Promise<ListAgentUsersData> => {
  const response = await api.post<ListAgentUserResponse>('/agent-v2/list-agent-user', {
    page,
    page_size: pageSize,
    agent_id: agentId,
    search_type: searchType,
    input_text: inputText,
    role_type: roleType,
    role_status: roleStatus,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
